import { appendSocialCardFreshness, buildSocialCardFreshnessValue } from "../../shared/socialCardFreshness";

export function buildMarketShareUrl({ market, origin, affiliateId, now = new Date() }) {
  const safeOrigin = String(origin || "").trim();
  if (!market?.id || !safeOrigin) {
    return "#";
  }

  const marketUrl = appendSocialCardFreshness(
    buildShareTargetUrl({ origin: safeOrigin, path: `/market/${market.id}`, affiliateId }),
    buildSocialCardFreshnessValue(now)
  );
  return buildXIntentUrl({
    text: `I am backing a side on RaizIQ: ${String(market.title || "").trim()}`,
    targetUrl: marketUrl
  });
}

export function buildHomepageShareUrl({ origin, affiliateId }) {
  const safeOrigin = String(origin || "").trim();
  if (!safeOrigin) {
    return "#";
  }

  const homepageUrl = buildShareTargetUrl({ origin: safeOrigin, path: "/", affiliateId });
  return buildXIntentUrl({
    text: "Stop waiting for things to happen. Make them happen.",
    targetUrl: homepageUrl
  });
}

function buildXIntentUrl({ text, targetUrl }) {
  const intentUrl = new URL("https://twitter.com/intent/tweet");
  intentUrl.searchParams.set("text", `${text}\n${targetUrl.toString()}`);
  return intentUrl.toString();
}

function buildShareTargetUrl({ origin, path, affiliateId }) {
  const targetUrl = new URL(path, origin);
  const safeAffiliateId = String(affiliateId || "").trim();
  if (safeAffiliateId) {
    targetUrl.searchParams.set("aff", safeAffiliateId);
  }

  return targetUrl;
}
